import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@/components/TextComponent';
import { Row } from '@/components/lib/components';
import { AppColors, getThemeColorHexValue } from '@/components/lib/theme';
import { withOpacity } from '@/styles/styles';

type PaymentTagTranslationKeys = 'expired' | 'fastest' | 'popular' | 'preferred';

export interface PaymentTagProps {
    translationKey: PaymentTagTranslationKeys;
    color: AppColors;
    backgroundColor?: string;
    icon?: React.ReactNode;
}

export const PaymentTag: React.FC<PaymentTagProps> = ({ icon, translationKey, color, backgroundColor }) => {
    const { t } = useTranslation('common');
    return (
        <Row
            alignItems={'center'}
            gap={'s4'}
            py={'s4'}
            px={'s8'}
            mx={'s12'}
            borderRadius="r7"
            style={{ backgroundColor: backgroundColor ?? withOpacity(getThemeColorHexValue(color), 0.16) }}
        >
            {icon}
            <Text variant="labelMedium" color={color}>
                {t(translationKey)}
            </Text>
        </Row>
    );
};
